"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftGroupingResponseToJSON = exports.GetNftGroupingResponseFromJSONTyped = exports.GetNftGroupingResponseFromJSON = void 0;
var _1 = require("./");
function GetNftGroupingResponseFromJSON(json) {
    return GetNftGroupingResponseFromJSONTyped(json, false);
}
exports.GetNftGroupingResponseFromJSON = GetNftGroupingResponseFromJSON;
function GetNftGroupingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nftGrouping': (0, _1.NftGroupingFromJSON)(json['nftGrouping']),
        'nftTrackers': (json['nftTrackers'].map(_1.NftTrackerFromJSON)),
    };
}
exports.GetNftGroupingResponseFromJSONTyped = GetNftGroupingResponseFromJSONTyped;
function GetNftGroupingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nftGrouping': (0, _1.NftGroupingToJSON)(value.nftGrouping),
        'nftTrackers': (value.nftTrackers.map(_1.NftTrackerToJSON)),
    };
}
exports.GetNftGroupingResponseToJSON = GetNftGroupingResponseToJSON;
